import {
	RemoveSpaceCapacityWindowMutation,
	RemoveSpaceTypeCapacityMutation,
	ReplaceSpaceCapacityWindowMutation,
	SetSpaceCapacityWindowMutation,
	SetSpaceTypeCapacityMutation
} from "~/gql/mutations/produce/spaceCapacity.generated";
import {
	GetSpaceCapacityWindowsQuery,
	GetSpaceTypeCapacitiesQuery
} from "~/gql/queries/produce/spaceCapacity.generated";

export const spaceCapacityEndpoints = {
	// Accepted exception: a reconcile read that finds a window changed elsewhere refreshes the grid from useSpaceCapacityMutations, because only the hook knows the read's outcome.
	GetSpaceCapacityWindows: {
		providesTags: ["SpaceCapacityWindows"] as AddTagTypes,
		transformResponse: (res: GetSpaceCapacityWindowsQuery) => res
	},
	GetSpaceTypeCapacities: {
		providesTags: ["SpaceCapacityWindows"] as AddTagTypes,
		transformResponse: (res: GetSpaceTypeCapacitiesQuery) => res
	},
	RemoveSpaceCapacityWindow: {
		invalidatesTags: ["SpaceCapacityWindows", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: RemoveSpaceCapacityWindowMutation) => res
	},
	RemoveSpaceTypeCapacity: {
		invalidatesTags: ["SpaceCapacityWindows", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: RemoveSpaceTypeCapacityMutation) => res
	},
	ReplaceSpaceCapacityWindow: {
		invalidatesTags: ["SpaceCapacityWindows", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: ReplaceSpaceCapacityWindowMutation) => res
	},
	SetSpaceCapacityWindow: {
		invalidatesTags: ["SpaceCapacityWindows", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: SetSpaceCapacityWindowMutation) => res
	},
	SetSpaceTypeCapacity: {
		invalidatesTags: ["SpaceCapacityWindows", "SpaceUtilization"] as AddTagTypes,
		transformResponse: (res: SetSpaceTypeCapacityMutation) => res
	}
};
